'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reinitializeI18n = exports.initialize = exports.formatDateWithTemplate = exports.formatHTMLMessage = exports.formatPlurals = exports.t = undefined;

var _properaTranslator = require('@freightos/propera-translator');

Object.defineProperty(exports, 't', {
  enumerable: true,
  get: function get() {
    return _properaTranslator.t;
  }
});
Object.defineProperty(exports, 'formatPlurals', {
  enumerable: true,
  get: function get() {
    return _properaTranslator.formatPlurals;
  }
});
Object.defineProperty(exports, 'formatHTMLMessage', {
  enumerable: true,
  get: function get() {
    return _properaTranslator.formatHTMLMessage;
  }
});
Object.defineProperty(exports, 'formatDateWithTemplate', {
  enumerable: true,
  get: function get() {
    return _properaTranslator.formatDateWithTemplate;
  }
});
Object.defineProperty(exports, 'initialize', {
  enumerable: true,
  get: function get() {
    return _properaTranslator.initialize;
  }
});

var _utils = require('./utils');

if ((0, _utils.shouldLoadLocaleData)('propera-fw')) {
  var localeData = {};
  try {
    localeData = require('./../../../public/assets/localeData/' + (0, _utils.getLanguageWithoutRegionCode)() + '.json');
  } catch (error) {
    localeData = require('./../../../public/assets/localeData/en.json');
  }
  (0, _utils.setPackageLocaleData)('propera-fw', localeData);
}

(0, _properaTranslator.initialize)(window.locale, (0, _utils.getAllMessages)(), null, window.dateFormat);

var reinitializeI18n = exports.reinitializeI18n = function reinitializeI18n() {
  (0, _properaTranslator.initialize)(window.locale, (0, _utils.getAllMessages)(), null, window.dateFormat);
};